<template>
  <li
    class="list-group-item border-0 flex-column flex-wrap p-3 mb-3 border-radius-lg align-items-start justify-content-between"
    style="background-color: rgb(230, 230, 230)"
  >
    <div
      :id="`hopperAccordion-${hopperId}`"
      class="accordion"
    >
      <div class="accordion-item">
        <h2
          :id="`hopper-heading-${hopperId}`"
          class="accordion-header"
        >
          <button
            class="accordion-button p-2"
            type="button"
            data-bs-toggle="collapse"
            :data-bs-target="`#hopper-collapse-${hopperId}`"
            aria-expanded="true"
            :aria-controls="`hopper-collapse-${hopperId}`"
            style="background: none;"
          >
            <div class="w-100 d-flex align-items-center justify-content-between">
              <div class="d-flex align-items-center">
                <h6 class="mb-0 ms-n2" style="font-size: 1rem">
                  {{ hopperName }}
                </h6>
                <i
                  class="fa fa-chevron-down ms-2"
                  aria-hidden="true"
                  style="font-size: 0.9rem"
                ></i>
                <i
                  class="fa fa-chevron-up ms-2"
                  aria-hidden="true"
                  style="font-size: 0.9rem"
                ></i>
              </div>
              <div class="d-flex align-items-center">
                <span class="me-2" style="font-size: 0.9rem">
                  PLC <span style="font-size: 0.8rem">connection</span>
                </span>
                <span class="badge badge-dot">
                  <i
                    :class="plcStatus ? 'bg-success' : 'bg-danger'"
                    style="width: 13px; height: 13px; display: inline-block; border-radius: 50%;">
                  </i>
                </span>
              </div>
            </div>
          </button>
        </h2>
        <div
          :id="`hopper-collapse-${hopperId}`"
          class="accordion-collapse collapse show"
          :aria-labelledby="`hopper-heading-${hopperId}`"
          :data-bs-parent="`#hopperAccordion-${hopperId}`"
        >
          <div class="accordion-body p-0">
            <send-recipes-recipe-card
              v-for="[recipe_id, recipe_data] in Object.entries(recipeDataByRecipeId)"
              :key="recipe_id"
              :recipe-id="recipe_id"
              :recipe-name="recipe_data.recipe_name"
              :updated-at="recipe_data.updated_at"
              :current-powder-amount-setting-by-gun-id="recipe_data.current_powder_amount_setting_by_gun_id"
              :new-powder-amount-setting-by-gun-id="recipe_data.new_powder_amount_setting_by_gun_id"
              :new-powder-amount-setting-id-by-gun-id="recipe_data.new_powder_amount_setting_id_by_gun_id"
              :new-reduction-factor-1-by-gun-id="recipe_data.new_reduction_factor_1_by_gun_id || {}"
              :new-reduction-factor-2-by-gun-id="recipe_data.new_reduction_factor_2_by_gun_id || {}"
              :gun-names-by-gun-id="gunNamesByGunId"
              @reload-data="$emit('reload-data')"
            />
          </div>
        </div>
      </div>
    </div>
  </li>
</template>

<script>
import SendRecipesRecipeCard from "@/views/applications/steelcase/components/SendRecipesRecipeCard.vue";

export default {
  name: "SendRecipesHopperCard",
  components: {
    SendRecipesRecipeCard,
  },
  props: {
    hopperId: {
      type: String,
      default: "",
    },
    hopperName: {
      type: String,
      default: "",
    },
    plcStatus: {
      type: Boolean,
      default: true,
    },
    recipeDataByRecipeId: {
      type: Object,
      default: () => ({}),
    },
    gunNamesByGunId: {
      type: Object,
      default: () => ({}),
    },
  },
  emits: [
    "reload-data",
  ],
  data() {
    return {};
  },
  mounted() {},
  methods: {},
};
</script>
